(ns app.strive-forms.components
  (:require [app.components.icons.views :refer [avatar back-arrow-form-icon
                                                chevron-up-icon
                                                next-arrow-form-icon]]
            [app.strive-forms.component-multi-methods :refer [show-action-btn?
                                                              update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as events]
            [app.strive-forms.helper-functions :as helper-functions :refer [component-alignment get-question-description submit-if-final-question]]
            [app.strive-forms.question-components :refer [question-title-area]]
            [app.strive-forms.question-fields.boolean-field :refer [bool-field]]
            [app.strive-forms.question-fields.date-field :refer [date-field]]
            [app.strive-forms.question-fields.dropdown-field :refer [dropdown-field]]
            [app.strive-forms.question-fields.email-input-field :refer [email-input-field]]
            [app.strive-forms.question-fields.grid-field :refer [grid-question]]
            [app.strive-forms.question-fields.legal-statement :refer [legal-statement-field]]
            [app.strive-forms.question-fields.multi-select :refer [multi-select-field]]
            [app.strive-forms.question-fields.number-input-field :refer [number-input-field]]
            [app.strive-forms.question-fields.number-scale :refer [number-scale-field]]
            [app.strive-forms.question-fields.phone-number :refer [phone-number-field]]
            [app.strive-forms.question-fields.text-field :refer [text-input-field]]
            [app.strive-forms.question-fields.thank-you :refer [thank-you-field]]
            [app.strive-forms.question-fields.welcome-screen :refer [welcome-screen]]
            [app.strive-forms.styles :refer [action-button-area-style
                                             action-button-style
                                             empty-blank-space-style footer-style-left-side footer-style-right-side form-page-footer-style
                                             languages-dropdown-style linear-progress-style num-of-steps-style
                                             page-sticky-title-style page-subtitle-style page-title-style phone-input-warning-notification
                                             progress-label-style question-card-style question-description-field-style
                                             question-gap-style question-title-area-style questions-icons-area-style]]
            [clojure.string :as s]
            [goog.string :as gstring]
            [goog.string.format]
            [keybind.core :as key]
            [re-com.box :refer [gap]]
            [re-com.core :as re-com :refer [at h-box single-dropdown v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.material.linear-progress :refer [linear-progress]]
            [reagent-mui.material.tooltip :refer [tooltip]]))

(defn icon-with-tooltip [{:keys [label icon on-click]}]
  [h-box
   :children [[tooltip {:title label
                        :arrow false}
               [:button {:class (empty-blank-space-style {:width "none"})
                         :on-click on-click}
                icon]]]])

(defn page-interaction-button [{:keys [condition label icon on-click]}]
  (if condition
    [icon-with-tooltip {:label label :icon icon :on-click on-click}]
    [:div {:class (empty-blank-space-style {:width "31px"})}]))

(defn steps-field [{:keys [theme-data steps-text-field show?]}]
  (when show?
    [:p {:class
         (num-of-steps-style {:color (or (:descriptons_color theme-data) (:dark-gray (:themes default-values)))})}
     steps-text-field]))

(defn avatar-icon [{:keys [avatar-img-link show?]}]
  (if show?
    [avatar {:src avatar-img-link}]
    [:div {:class (empty-blank-space-style {:width "80px"})}]))

(defn gap-space [{:keys [primary-gap secondary-gap]}]
  [:div {:class (question-gap-style
                 {:primary-gap primary-gap
                  :secondary-gap secondary-gap})}])

(defn form-page-header [{:keys [current-page step steps-total theme-data form-messages avatar-img-link language-direction has-thank-you-screen? missing-required-fields]}]
  (let [steps-text-field (str (:step_text form-messages (:step_text default-values)) " " @step "/" @steps-total)
        back-tooltip (:back_tooltip form-messages (:back_tooltip default-values))
        next-tooltip (:next_tooltip form-messages (:next_tooltip default-values))
        show-steps-field? true
        show-avatar? true
        previous-page? (and (<= @step @steps-total) (> @current-page 0))
        next-page? (< @step @steps-total)
        previous-page! (fn []
                         (when-not (zero? (count @missing-required-fields))
                           (reset! missing-required-fields []))
                         (reset! current-page (dec @current-page)))
        next-page! (fn []
                     (when-not (zero? (count @missing-required-fields))
                       (reset! missing-required-fields []))
                     (reset! current-page (inc @current-page)))]
    (if (= language-direction "RTL")
      (do (if next-page? (key/bind! "left" ::my-trigger next-page!) (key/unbind! "left" ::my-trigger))
          (if previous-page? (key/bind! "right" ::my-trigger previous-page!) (key/unbind! "right" ::my-trigger)))
      (do (if previous-page? (key/bind! "left" ::my-trigger previous-page!) (key/unbind! "left" ::my-trigger))
          (if next-page? (key/bind! "right" ::my-trigger next-page!) (key/unbind! "right" ::my-trigger))))

    (when (not (and has-thank-you-screen? (= @step (inc @steps-total))))
      [v-box
       :class (question-title-area-style)
       :justify :center
       :align :center
       :children [(if (= language-direction "RTL")
                    [h-box
                     :justify :between
                     :class (questions-icons-area-style)
                     :children [[page-interaction-button {:label next-tooltip :icon [back-arrow-form-icon {:width "19px"
                                                                                                           :height "34px"}] ;size
                                                          :condition next-page?
                                                          :on-click next-page!}]
                                [avatar-icon {:avatar-img-link avatar-img-link :show? show-avatar?}]
                                [page-interaction-button {:label back-tooltip :icon [next-arrow-form-icon {:width "19px"
                                                                                                           :height "34px"}]
                                                          :condition previous-page?
                                                          :on-click previous-page!}]]]
                    [h-box
                     :justify :between
                     :class (questions-icons-area-style)
                     :children [[page-interaction-button {:label back-tooltip :icon [back-arrow-form-icon {:width "19px"
                                                                                                           :height "34px"}]
                                                          :condition previous-page?
                                                          :on-click previous-page!}]
                                [avatar-icon {:avatar-img-link avatar-img-link :show? show-avatar?}]
                                [page-interaction-button {:label next-tooltip :icon [next-arrow-form-icon {:width "19px"
                                                                                                           :height "34px"}] ;height "19px"
                                                          :condition next-page?
                                                          :on-click next-page!}]]])
                  [gap-space {:primary-gap (:icon-to-steps-gield-gap (:gaps-primary default-values))
                              :secondary-gap (:icon-to-steps-gield-gap (:gaps-mobile-view default-values))}]
                  [steps-field {:theme-data theme-data :steps-text-field steps-text-field
                                :show? show-steps-field?}]]])))

(defn language-selection [{:keys [allowed-languages selected-language form-id]}]
  [v-box
   :class (question-title-area-style)
   :justify :center
   :align :center
   :children [[h-box
               :justify :end
               :class (questions-icons-area-style)
               :children
               [[single-dropdown
                 :src        (at)
                 :choices    allowed-languages
                 :model      selected-language
                 :width      "150px"
                 :class (languages-dropdown-style)
                 :id-fn       (comp str :isoCode)
                 :label-fn    (comp str :native_name)
                 :on-change  #(re-frame/dispatch [::events/update-selected-form-language {:value % :form-id form-id}])]]]]])

(defn page-title [{:keys [field theme-data position selected-language]}]
  (let [title-component-width (if (= position :body) (:width (:page-title default-values)) nil)
        font-family (or
                     (:font_family (:field_style field) (:font theme-data))
                     (:font-family (:page-title default-values)))
        font-size (str (:font_size (:field_style field) (:font-size (:page-title default-values))) "px")
        font-color (or
                    (:color (:field_style field) (:questions_color theme-data))
                    (:color (:page-title default-values)))
        text-align (:align (:page-title default-values))
        question-title-height (if (= "welcome_screen" (:type field)) "100%" "200px")
        background-color (if (= position :body) nil "rgba(0, 0, 0, 0.1)")]
    [:div {:class (if (= position :body)
                    (page-title-style font-family font-color font-size text-align title-component-width question-title-height
                                      background-color)
                    (page-sticky-title-style font-family font-color font-size text-align title-component-width question-title-height
                                             background-color))
           :id (if (= position :body)
                 (str "page-title-" (:id field))
                 (str "page-sticky-title-" (:id field)))}
     (get (:page_title field) (keyword selected-language))]))

(defn page-subtitle [{:keys [field theme-data selected-language]}]
  (let [subtitle (or (get (:page_subtitle field) (keyword selected-language)) "")]
    (when (not (s/blank? page-subtitle))
      [:div {:class (page-subtitle-style {:theme-data (:descriptons_color theme-data
                                                                          (:dark-gray (:themes default-values)))})}
       subtitle])))

(defn multi-question-page-header-slider [{:keys [field  theme-data selected-language]}]
  [:div {:id (str "page-sticky-title-div-" (:id field))}
   [page-title {:field field :theme-data theme-data :selected-language selected-language}]
   [page-subtitle {:field field :theme-data theme-data :selected-language selected-language}]
   [gap-space {:primary-gap (:page-title-to-questions-in-multi (:gaps-primary default-values))
               :secondary-gap (:page-title-to-questions-in-multi (:gaps-mobile-view default-values))}]])

(defn multi-question-page-header [{:keys [field  theme-data selected-language]}]
  [:div {:id (str "page-title-div-" (:id field))}
   [page-title {:field field :theme-data theme-data :selected-language selected-language :position :body}]
   [page-subtitle {:field field :theme-data theme-data :selected-language selected-language}]
   [gap-space {:primary-gap (:page-title-to-questions-in-multi (:gaps-primary default-values))
               :secondary-gap (:page-title-to-questions-in-multi (:gaps-mobile-view default-values))}]])

(defn question-description [{:keys [field selected-language theme-data is-multi-question?]}]
  (let [description (get-question-description field selected-language)]
    (when (not (s/blank? description))
      [v-box
       :class (question-description-field-style {:theme-data (:descriptons_color theme-data
                                                                                 (:dark-gray (:themes default-values)))})
       :align (component-alignment is-multi-question?)
       :style {:text-align (if is-multi-question? "start" "center")}
       :width "100%"
       :children [description]])))

(def field-type->question-input
  {"number_scale" number-scale-field
   "text" text-input-field
   "boolean" bool-field
   "legal_statement" legal-statement-field
   "phone_number" phone-number-field
   "thank_you_screen" thank-you-field
   "email" email-input-field
   "number" number-input-field
   "multi_select" multi-select-field
   "dropdown" dropdown-field
   "date" date-field "grid_question" grid-question
   "welcome_screen" welcome-screen})

(defn question-input [{:keys [field] :as field-data}]
  (let [question-input
        (get field-type->question-input (:type field)
             text-input-field)]
    (case (:type field)
      "number_scale" number-scale-field
      "text" text-input-field
      "boolean" bool-field
      "legal_statement" legal-statement-field
      "phone_number" phone-number-field
      "thank_you_screen" thank-you-field
      "email" email-input-field
      "number" number-input-field
      "multi_select" multi-select-field
      "dropdown" dropdown-field
      "date" date-field
      "welcome_screen" welcome-screen
      "grid_question" grid-question
      text-input-field)
    [question-input field-data]))

(defn question-card [{:keys [visible? visible-id?]
                      :as field-data}  _]
  (if (= @(:current-page field-data)
         (:index field-data))
    (do (reset! visible? true)
        (reset! visible-id? (:field-id field-data)))
    (reset! visible? false))
  [v-box
   :justify :center
   :max-height "80%"
   :align :center
   :style {:height (when (= "thank_you_screen" (:type (:field field-data))) "55vh")}
   :class (question-card-style)
   :children [[question-title-area field-data]
              [question-description field-data]
              [gap-space {:primary-gap (:question-desc-to-question-input (:gaps-primary default-values))
                          :secondary-gap (:question-desc-to-question-input (:gaps-mobile-view default-values))}]

              [question-input field-data]]])

(defn required-nil-field? [value key display-fields]
  (and (:is-required value) (nil? (:value value)) (some #(= (name key) (:id %)) display-fields)))

(defn submit-button-verification [{:keys [final-page? missing-required-fields display-fields input-data grouped-display-fields
                                          on-submit is-preview-btn? current-page index input-data-value]}]

  ;;keep
  (let [required-nil-field-list (->> input-data
                                     (map (fn [[key value]]
                                            (when (required-nil-field? value key display-fields)
                                              (name key))))
                                     (remove nil?)
                                     (into #{}))
        missing-required-fields-array (->> (map-indexed
                                            (fn [index {:keys [fields]}]
                                              (->> fields
                                                   (map #(:id %))
                                                   (filter required-nil-field-list)
                                                   (map (fn [item]
                                                          {:page-num index :field-id item}))))
                                            grouped-display-fields)
                                           (reduce into []))]
    (reset! missing-required-fields missing-required-fields-array)
    (if (zero? (count missing-required-fields-array))
      (submit-if-final-question {:final-page? final-page?
                                 :input-data input-data
                                 :on-submit on-submit})
      (reset! is-preview-btn? true))
    (when-not @is-preview-btn? (reset! current-page (inc index)))))

(defn welcome-screen? [fields]
  (and (= "welcome_screen" (:type (first fields))) (= 1 (count fields))))

(defn one-question-per-page? [fields]
  (= 1 (count fields)))

(defn multi-select-question? [fields]
  (= (:type (first fields)) "multi_select"))

(defn grid_number-question? [fields]
  (= (:type (first fields)) "grid_question"))

(defn text-question? [fields]
  (= (:type (first fields)) "text"))

(defn evaluate-button-for-question [{:keys [fields current-page index final-page? input-data on-submit input-value regenerate-display-fields
                                            missing-required-fields display-fields grouped-display-fields is-preview-btn? cache-data]}]
  (if (or (multi-select-question? fields) (text-question? fields) (grid_number-question? fields))
    (do
      (reset! current-page (inc index))
      (submit-if-final-question {:final-page? final-page? :input-data input-data :on-submit on-submit}))

    (do 
      (update-question-input-local {:field-id (:id (first fields)) :input-data input-data
                                    :type (:type (first fields)) :input-value (:input-value (first @input-value))})
      (regenerate-display-fields
       (update-question-input-data {:field-id (:id (first fields))
                                    :input-data input-data
                                    :type (:type (first fields))
                                    :input-value (:input-value (first @input-value))}))
      (cache-data input-data)
      (if final-page?
        (submit-button-verification {:final-page? final-page? :missing-required-fields missing-required-fields
                                     :display-fields display-fields :input-data input-data
                                     :grouped-display-fields grouped-display-fields :input-value input-value
                                     :on-submit on-submit :is-preview-btn? is-preview-btn? :current-page current-page
                                     :index index  :input-data-value (update-question-input-data {:field-id (:id (first fields))
                                                                                                  :input-data input-data
                                                                                                  :type (:type (first fields))
                                                                                                  :input-value (:input-value (first @input-value))})})
        (reset! current-page (inc index))))))

(defn- evaluate-button-for-page [{:keys [input-value input-data regenerate-display-fields final-page? missing-required-fields
                                         display-fields grouped-display-fields on-submit is-preview-btn? current-page index cache-data]}]
  (let [page-input-data (into {}
                              (map (fn [[key input-data-value]]
                                     (if (some #(=  (keyword (:id %)) key) @input-value)
                                       {key (assoc input-data-value :value (:input-value (some #(when (= (keyword (:id %)) key) %) @input-value)))}
                                       {key (assoc input-data-value :value (:value input-data-value))})) input-data))]
    (re-frame/dispatch [::events/update-input-data-array-local {:input-data page-input-data}])
    (regenerate-display-fields page-input-data)
    (cache-data page-input-data)
    (if final-page? 
      (submit-button-verification {:final-page? final-page? :missing-required-fields missing-required-fields
                                   :display-fields display-fields :input-data input-data
                                   :grouped-display-fields grouped-display-fields :input-value input-value
                                   :on-submit on-submit :is-preview-btn? is-preview-btn? :current-page current-page
                                   :index index  :input-data-value page-input-data})
      (reset! current-page (inc index)))))

(defn action-button-click [{:keys [fields current-page index final-page? input-data on-submit input-value regenerate-display-fields
                                   missing-required-fields display-fields grouped-display-fields is-preview-btn? cache-data]}]
  ;;use cond
  (if (welcome-screen? fields)
    (reset! current-page (inc index))
    (if (one-question-per-page? fields)
      (evaluate-button-for-question {:fields fields
                                     :current-page current-page :index index :final-page? final-page?
                                     :input-data input-data :on-submit on-submit :input-value input-value
                                     :regenerate-display-fields regenerate-display-fields :missing-required-fields missing-required-fields
                                     :display-fields display-fields :grouped-display-fields grouped-display-fields
                                     :is-preview-btn? is-preview-btn? :cache-data cache-data})
      (evaluate-button-for-page {:input-value input-value :input-data input-data
                                 :regenerate-display-fields regenerate-display-fields :final-page? final-page?
                                 :missing-required-fields missing-required-fields :display-fields display-fields
                                 :grouped-display-fields grouped-display-fields :on-submit on-submit :is-preview-btn? is-preview-btn?
                                 :current-page  current-page :index index :cache-data cache-data}))))

(defn action-button [{:keys [fields is-multi-question?]}]
  (when (or (and
             (= (count fields) 1)
             (show-action-btn? {:type (:type (first fields))}))
            is-multi-question?)
    (fn [{:keys [fields index input-data theme-data current-page
                 regenerate-display-fields on-submit button-label input-value
                 button-ids-for-button final-page? display-fields grouped-display-fields is-preview-btn? missing-required-fields cache-data]}]
      [v-box
       :width "100%"
       :class (action-button-area-style)
       :src (at)
       :gap "10px"
       :children [(when @is-preview-btn? [:div {:class (phone-input-warning-notification)
                                                :style {:margin-bottom "15px"}}
                                          "Some required fields are missing!"])

                  (if @is-preview-btn?
                    [re-com/button
                     :label "Review"
                     :class (action-button-style {:theme-data theme-data :preview true})
                     :on-click (fn [] (reset! current-page (:page-num (first @missing-required-fields)))
                                 ;;when-let
                                 (when (.getElementById js/document (str "question-field-area-" (:field-id (first @missing-required-fields))))
                                   (.scrollIntoView (.getElementById js/document (str "question-field-area-" (:field-id (first @missing-required-fields))))
                                                    #js{:block "center" :inline "center" :behavior "auto"})))]
                    [re-com/button
                     :attr {:id
                            (str "action-btn" @current-page)}
                     :label (or button-label "Next")
                     :class (action-button-style {:theme-data theme-data})
                     :disabled? (and (not= (:type (first fields)) "welcome_screen") (not final-page?) (not-empty @button-ids-for-button))

                     :on-click (fn []
                                 (action-button-click {:fields fields :current-page current-page :index index :final-page? final-page?
                                                       :input-data input-data :on-submit on-submit :input-value input-value :regenerate-display-fields regenerate-display-fields
                                                       :missing-required-fields missing-required-fields :display-fields display-fields
                                                       :grouped-display-fields grouped-display-fields
                                                       :is-preview-btn? is-preview-btn? :cache-data cache-data}))])]])))

(defn form-page-footer [{:keys [form-messages]}]
  (let [powered-by (:powered_by form-messages (:powered_by default-values))]
    [h-box
     :justify :between
     :children [[:div
                 {:class (form-page-footer-style)}
                 [:p {:class (footer-style-left-side)} powered-by]
                 [:p {:class (footer-style-right-side)} "Strive"]]]]))

(defn progress-bar-componenet [{:keys [theme-data progress is-mobile is-drawer]}]
  [:div
   [h-box
    :justify :between
    :children
    [[:span
      {:class (progress-label-style {:description-color (if (> (.-innerWidth js/window) 1100)
                                                          (:descriptons_color theme-data
                                                                              (:dark-gray (:themes default-values)))
                                                          (:buttons_color theme-data))})}
      "Progress"]
     (when (and is-drawer is-mobile) [chevron-up-icon {:size "24px"}])
     (when-not is-mobile
       [:span
        {:class (progress-label-style {:description-color (:descriptons_color theme-data
                                                                              (:dark-gray (:themes default-values)))})}
        (str (gstring/format "%.0f" @progress) "%")])]]
   [gap :size "8px"]
   [linear-progress {:variant "buffer"
                     :value @progress
                     :valueBuffer 100
                     :aria-label "linear-progress"
                     :class (linear-progress-style {:primary-color (:buttons_color theme-data (:primary (:themes default-values)))
                                                    :background-color (str (:answers_border_color theme-data) "dc")})}]])